<template>
    <section class="productsSolar">
      <div class="title">
        <h2>ENERGIA SOLAR</h2>
        <hr />
      </div>
      <div class="categoriesProduct">
        <aside class="sidebar sidebar--desktop" style="width: 28% !important; height: 100%;">
          <h2 class="sidebar__title">Filtrar</h2>

          <div class="sidebar__options">
            <!-- Departamentos -->
            <div v-if="filtros.departamentos && filtros.departamentos.length > 0 ">
              <h2>Departamentos</h2>
              <v-radio-group v-model="filtroDepartamentos">
                <v-radio
                  v-for="(f, i) in filtros.departamentos"
                  :key="'Marcas' + i"
                  :label="f.replace('*', '')"
                  :value="f"
                  color="#005a64"
                  @click="montaUrlFiltros(true)"
                ></v-radio>
              </v-radio-group>
              <br>
            </div>
            <!-- Categorias -->
            <div v-if="filtros.categorias && filtros.categorias.length > 0 && !(filtroDepartamentos === '*Itens Avulsos')">
              <v-app>
                <v-divider></v-divider>
              </v-app>
              <h2>Categorias</h2>
              <div 
                v-for="(f, i) in filtros.categorias"
                :key="'Categorias' + i">

                <v-checkbox
                  :label="f.replace('*', '')"
                  v-model="filtroCategorias"
                  color="#005a64"
                  :value="f"
                  hide-details
                  @click="montaUrlFiltros()"
                ></v-checkbox>
              </div>
              <br>
            </div>
            <!-- Marcas -->
            <div v-if="filtros.marcas.length > 0">
              <v-app>
                <v-divider></v-divider>
              </v-app>
              <h2>Marcas</h2>
              <div 
                v-for="(f, i) in filtros.marcas"
                :key="'Marcas' + i">

                <v-checkbox
                  :label="f.replace('*', '')"
                  v-model="filtroMarcas"
                  color="#005a64"
                  :value="f"
                  hide-details
                  @click="montaUrlFiltros()"
                ></v-checkbox>
              </div>
              <br>
            </div>
            
            <!-- Não exibe filtros abaixo para Itens Avulsos -->
            <div v-if="!(filtroDepartamentos === '*Itens Avulsos')">
              <div v-if="filtros.potencias && filtros.potencias.length > 0">
                <v-app>
                  <v-divider></v-divider>
                </v-app>
                <!-- Faixa de Potência -->
                <h2>Potência do Inversor</h2>
                <div style="margin-top: 25px;">
                  <vue-slider 
                    v-model="potenciaSelecionada" 
                    v-bind="optionsRangeSlide" 
                    :data="filtros.potencias"
                    @change="montaUrlFiltros(false, true)"
                  ></vue-slider>
                  <div>
                    <span>{{ potenciaSelecionada[0] }} KW</span>
                    <span style="float: right;">{{ potenciaSelecionada[1] }} KW</span>
                  </div>
                </div>
                <br>
              </div>

              <!-- Tipo de Geradores -->
              <div v-if="filtros.geradores.length > 0">
                <v-app>
                  <v-divider></v-divider>
                </v-app>
                <h2>Tipo de Gerador</h2>
                <div 
                  v-for="(f, i) in filtros.geradores"
                  :key="'Geradores' + i">

                  <v-checkbox
                    :label="f.replace('*', '')"
                    v-model="filtroGeradores"
                    color="#005a64"
                    :value="f"
                    hide-details
                    @click="montaUrlFiltros()"
                  ></v-checkbox>
                </div>
                <br>
              </div>
              <!-- Voltagens -->
              <div v-if="filtros.voltagens.length > 0">
                <v-app>
                  <v-divider></v-divider>
                </v-app>
                <h2>Voltagens</h2>
                <div 
                  v-for="(f, i) in filtros.voltagens"
                  :key="'Voltagens' + i">

                  <v-checkbox
                    :label="f.replace('*', '')"
                    v-model="filtroVoltagens"
                    color="#005a64"
                    :value="f"
                    hide-details
                    @click="montaUrlFiltros()"
                  ></v-checkbox>
                </div>
              </div>
            </div>
            <br>
          </div>
        </aside>

        <aside class="sidebar sidebar--mobile">
          <h2
            class="sidebar__title sidebar__title--mobile"
            @click="showFilter = !showFilter"
          >
            Filtrar
          </h2>
          <div
            v-if="showFilter"
            class="sidebar__options"
          >
            <!-- Departamentos -->
            <div v-if="filtros.departamentos && filtros.departamentos.length > 0 ">
              <h2>Departamentos</h2>
              <v-radio-group v-model="filtroDepartamentos">
                <v-radio
                  v-for="(f, i) in filtros.departamentos"
                  :key="'Marcas' + i"
                  :label="f.replace('*', '')"
                  :value="f"
                  color="#005a64"
                  @click="montaUrlFiltros(true)"
                ></v-radio>
              </v-radio-group>
              <br>
            </div>
            <!-- Categorias -->
            <div v-if="filtros.categorias && filtros.categorias.length > 0 && !(filtroDepartamentos === '*Itens Avulsos')">
              <v-app>
                <v-divider></v-divider>
              </v-app>
              <h2>Categorias</h2>
              <div 
                v-for="(f, i) in filtros.categorias"
                :key="'Categorias' + i">

                <v-checkbox
                  :label="f.replace('*', '')"
                  v-model="filtroCategorias"
                  color="#005a64"
                  :value="f"
                  hide-details
                  @click="montaUrlFiltros()"
                ></v-checkbox>
              </div>
              <br>
            </div>
            <!-- Marcas -->
            <div v-if="filtros.marcas.length > 0">
              <v-app>
                <v-divider></v-divider>
              </v-app>
              <h2>Marcas</h2>
              <div 
                v-for="(f, i) in filtros.marcas"
                :key="'Marcas' + i">

                <v-checkbox
                  :label="f.replace('*', '')"
                  v-model="filtroMarcas"
                  color="#005a64"
                  :value="f"
                  hide-details
                  @click="montaUrlFiltros()"
                ></v-checkbox>
              </div>
              <br>
            </div>
            
            <!-- Não exibe filtros abaixo para Itens Avulsos -->
            <div v-if="!(filtroDepartamentos === '*Itens Avulsos')">
              <div v-if="filtros.potencias && filtros.potencias.length > 0">
                <v-app>
                  <v-divider></v-divider>
                </v-app>
                <!-- Faixa de Potência -->
                <h2>Potência do Inversor</h2>
                <div style="margin-top: 25px;">
                  <vue-slider 
                    v-model="potenciaSelecionada" 
                    v-bind="optionsRangeSlide" 
                    :data="filtros.potencias"
                    @change="montaUrlFiltros(false, true)"
                  ></vue-slider>
                  <div>
                    <span>{{ potenciaSelecionada[0] }} KW</span>
                    <span style="float: right;">{{ potenciaSelecionada[1] }} KW</span>
                  </div>
                </div>
                <br>
              </div>

              <!-- Tipo de Geradores -->
              <div v-if="filtros.geradores.length > 0">
                <v-app>
                  <v-divider></v-divider>
                </v-app>
                <h2>Tipo de Gerador</h2>
                <div 
                  v-for="(f, i) in filtros.geradores"
                  :key="'Geradores' + i">

                  <v-checkbox
                    :label="f.replace('*', '')"
                    v-model="filtroGeradores"
                    color="#005a64"
                    :value="f"
                    hide-details
                    @click="montaUrlFiltros()"
                  ></v-checkbox>
                </div>
                <br>
              </div>
              <!-- Voltagens -->
              <div v-if="filtros.voltagens.length > 0">
                <v-app>
                  <v-divider></v-divider>
                </v-app>
                <h2>Voltagens</h2>
                <div 
                  v-for="(f, i) in filtros.voltagens"
                  :key="'Voltagens' + i">

                  <v-checkbox
                    :label="f.replace('*', '')"
                    v-model="filtroVoltagens"
                    color="#005a64"
                    :value="f"
                    hide-details
                    @click="montaUrlFiltros()"
                  ></v-checkbox>
                </div>
              </div>
            </div>
            <br>
          </div>
        </aside>

        <div class="product">
          <a-skeleton :loading="loading" active> </a-skeleton>
          <div class="product__void" v-if="!loading && infos && infos.length == 0">
            <div>
              <h2>
                Desculpe, não encontramos nenhum resultado para sua busca :(
              </h2>
              <p>Recomendados que tente realizar uma nova busca.</p>
              <p>
                <router-link to="/">Voltar a página inicial</router-link>
              </p>
            </div>
          </div>
          <div 
            v-for="(info, index) in infos" :key="index" 
            @click="info.isCustomized ? productDetails(info.Nr_TabelaPrecoItem, info.vl_liquido_produto, info.isCustomized) : true"
            class="product__list" :class="info.isCustomized ? 'pointer' : true">
            <div
              class="imagem" 
              :class="!info.isCustomized ? 'pointer' : true"
              @click="!info.isCustomized ? productDetails(info.Nr_TabelaPrecoItem, info.vl_liquido_produto, info.isCustomized) : true">
              <img
                loading="lazy"
                class="product__image"
                v-lazy="info.ImagemItem"
                :alt="info.Ds_Item"
              />
            </div>
            <p class="product__name">
              {{ info.Ds_Item }}
            </p>
            <div v-if="!isSolar" class="product__price">
              <span class="price__per" v-if="info._Disponivel >= 1">
                {{ (info.vl_liquido_produto * 0.95) | toCurrency }}
                <span class="price__AtSight">à vista</span></span
              >
              <span class="price__priceTerm">
                ou <span> {{ info.vl_liquido_produto | toCurrency }}</span>
              </span>
              <span class="price__plots" v-if="info.vl_liquido_produto > 221">
                10x de
                {{ (info.vl_liquido_produto / 10) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 195 && info.vl_liquido_produto < 220
                "
              >
                8x de
                {{ (info.vl_liquido_produto / 8) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 175 && info.vl_liquido_produto <= 194
                "
              >
                7x de
                {{ (info.vl_liquido_produto / 7) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 150 && info.vl_liquido_produto <= 174
                "
              >
                6x de
                {{ (info.vl_liquido_produto / 6) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 120 && info.vl_liquido_produto <= 149
                "
              >
                5x de
                {{ (info.vl_liquido_produto / 5) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 100 && info.vl_liquido_produto <= 119
                "
              >
                4x de
                {{ (info.vl_liquido_produto / 4) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 80 && info.vl_liquido_produto <= 99
                "
              >
                3x de
                {{ (info.vl_liquido_produto / 3) | toCurrency }}
                sem juros</span
              >
              <span class="price__plots" v-if="info.vl_liquido_produto <= 79">
                2x de
                {{ (info.vl_liquido_produto / 2) | toCurrency }}
                sem juros</span
              >

              <span class="price__lower-quantity" v-if="info._Disponivel <= 5"
                >Poucas Unidades</span
              >
            </div>

            <!-- Exibe o valor dos produtos Solar -->
            <div v-else class="product__price">
              <span class="price__priceTerm" v-if="info._Disponivel >= 1">
                {{ info.vl_liquido_produto | toCurrency }}
              </span>
              <span class="price__per">
                {{
                  (info.vl_liquido_produto -
                    info.vl_liquido_produto * (info.DESCONTO_SOLAR / 100))
                    | toCurrency
                }}
                <span class="price__AtSight">à vista</span>
              </span>

              <span class="price__plots">
                Preço: de
                {{ moment(info.VALIDADE_DE).format("DD/MM/YYYY") }} até
                {{ moment(info.VALIDADE_ATE).format("DD/MM/YYYY") }}
              </span>
            </div>
            <div class="product__buttons" v-if="!info.isCustomized">
              <button
                class="product__buttons--details"
                @click="
                  productDetails(
                    info.Nr_TabelaPrecoItem,
                    info.vl_liquido_produto,
                    info.isCustomized
                  )
                "
              >
                <i class="fa fa-eye" aria-hidden="true"></i> Detalhes
              </button>

               <button v-if="!info.isCustomized" class="product__buttons--buy" @click="addMiniCart(info)">
                <i class="fa fa-shopping-cart" aria-hidden="true"></i> + Carrinho
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import axios from "axios";
import util from "../../util/util";

export default {
  data() {
    return {
      infos: null,
      loading: false,
      nomeCategoria: null,
      isSolar: null,
      filtrosSolar: null,
      showFilter: false,
      canalVenda: null,
      arrayPotencias: [],
      potenciaSelecionada: [0,0],
      fruits: 0,
      ticksLabels: [
        'Figs',
        'Lemon',
        'Pear',
        'Apple',
      ],
      filtros: {
        departamentos: [],
        marcas: [],
        categorias: [],
        geradores: [],
        voltagens: [],
        potencias: [],
      },
      // Parametros do Filtro
      filtroCategorias: [],
      filtroMarcas: [],
      filtroGeradores: [],
      filtroVoltagens: [],
      handlePotencia: false,
      optionsRangeSlide: {
        dotSize: 14,
        height: 3,
        interval: 1,
        dataLabel: "descricao",
        dataValue: "valor",
        marks: false,
        hideLabel: true,
        lazy: true,
        processStyle: { backgroundColor: '#005a64' },
        tooltipStyle: { backgroundColor: '#005a64', borderColor: '#005a64' }
      }
    };
  },
  created() {
    window.scrollTo(0,0);
  },
  methods: {
    montaUrlFiltros(altCategoria = false, altPotencia = false) {
      let url = "?";
      if (this.filtroDepartamentos.length > 0) {
        let stringDepartamento = `Departamentos=${this.filtroDepartamentos.toString()}&`;
        url += stringDepartamento;
        
        // Ao trocar a categoria recarrega a página sem os outros filtros
        if (altCategoria) {
          return window.location.href = url;
        }
      }
      if (this.filtroCategorias.length > 0) {
        let stringCategorias = `Categorias=${this.filtroCategorias.toString()}&`;
        url += stringCategorias;
      }
      if (this.filtroMarcas.length > 0) {
        let stringMarcas = `Marcas=${this.filtroMarcas.toString()}&`;
        url += stringMarcas;
      }
      if (this.filtroGeradores.length > 0) {
        let stringGeradores = `Geradores=${this.filtroGeradores.toString()}&`;
        url += stringGeradores;
      }
      if (this.filtroVoltagens.length > 0) {
        let stringVoltagens = `Voltagens=${this.filtroVoltagens.toString()}&`;
        url += stringVoltagens;
      }

      if (altPotencia || this.handlePotencia) {
        let stringPotencias = `Potencias=${this.potenciaSelecionada[0]}-${this.potenciaSelecionada[1]}&Handle=true&`;
        url += stringPotencias;
      }
      
      // Redireciona a página conforme filtros selecionados
      window.location.href = url;
    },
    alteracaoPotencia() {
      console.log("Potencia alterada")
    },
    decrementPotencia() {
      this.potenciaSelecionada = this.potenciaSelecionada - 1;
      this.montaUrlFiltros(false, true);
    },
    incrementPotencia() {
      this.potenciaSelecionada = this.potenciaSelecionada + 1;
      this.montaUrlFiltros(false, true);
    },
    recuperaTextoArrayPotencia(index) {
      return this.arrayPotencias[index];
    },
    productDetails(sku, preco, isCustomized) {
      localStorage.setItem(
        "precoDetails",
        JSON.stringify({ preco: preco, sku: sku })
      );

      const solar = JSON.parse(localStorage.getItem("isSaleSolar"));

      // Controle de params
      let route = "";
      if (!solar) {
        route = `details?sku=${sku}`;
      } else if (isCustomized && solar) {
        route = `details?sku=${sku}&isCustomized=true&isSolar=true`;
      } else {
        route = `details?sku=${sku}&isSolar=true`;
      }

      window.location.href = route;
    },
    addMiniCart(produto) {
      const solar = JSON.parse(localStorage.getItem("isSaleSolar"));
      // Valida o Carrinho
      if (!util.validaItensCarrinhoSolar(produto)) {
        return alert(
          `\n \n Ops.. \n Não é possível incluir ao carrinho itens de Revenda (Avulsos) e Kit's`
        );
      }
      let totalItens = 0;

      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];
      let productAdd = {
        sku: produto.Nr_TabelaPrecoItem,
        nomeItem: produto.Ds_Item,
        imagem: produto.ImagemItem,
        quantidade: 1,
        marca: produto.Marca,
        valor: produto.vl_liquido_produto,
        estoque: produto._Disponivel,
        isCustomized: produto.isCustomized,
        isSolar: solar,
      };

      if (carrinho.length > 0) {
        let validarItem = carrinho.find((x) => x.sku == productAdd.sku);
        if (validarItem != undefined && validarItem != null) {
          carrinho.forEach(function (e) {
            if (e.sku == productAdd.sku) {
              if (e.quantidade < productAdd.estoque) {
                e.quantidade = e.quantidade + 1;
              }
            }
          });
        } else {
          carrinho.push(productAdd);
        }
      } else {
        carrinho.push(productAdd);
      }
      carrinho.forEach(function (e) {
        totalItens = parseFloat(totalItens) + parseFloat(e.quantidade);
      });
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      document.getElementsByClassName("header__quantity")[0].innerText =
        totalItens;
      document.getElementsByClassName("header__cart")[0].click();
    },

    filtroClick(tipo, valor) {
      let url =
        "product?Categoria=Kit Energia Fotovoltaica" + "&" + tipo + "=" + valor;
      window.location.href = url;
    },

    async getDados() {
      try {
        // Ativa o Loading
        this.loading = true;

        // Recupera o canal a ser buscado os itens
        this.canalVenda = JSON.parse(localStorage.getItem("saleChannel"));
        this.isSolar = JSON.parse(localStorage.getItem("isSaleSolar"));
        let dados = JSON.parse(localStorage.getItem("login"));
        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        // Recupera parametros do filtro
        let departamentos = this.$route.query.Departamentos;
        if (departamentos) {
          this.filtroDepartamentos = departamentos;
        // Insere Departamento Default
        } else {
          this.filtroDepartamentos = "*Kit Energia Fotovoltaica";
        }

        let categorias = this.$route.query.Categorias;
        if (categorias) {
          this.filtroCategorias = categorias.split(',')
        }
        let marcas = this.$route.query.Marcas;
        if (marcas) {
          this.filtroMarcas = marcas.split(',')
        }
        let geradores = this.$route.query.Geradores;
        if (geradores) {
          this.filtroGeradores = geradores.split(',')
        }
        let voltagens = this.$route.query.Voltagens;
        if (voltagens) {
          this.filtroVoltagens = voltagens.split(',')
        }
        let potencias = this.$route.query.Potencias;
        this.handlePotencia = this.$route.query.Handle;

        let objPotencias = {
          min: null,
          max: null
        };

        // Busca os Filtos da Solar
        axios.get(`https://www.leverosintegra.com.br/Map/Api/solar?token=${this.token}&saleChannel=${this.canalVenda}&categoria=${this.filtroDepartamentos}`)
        .then(res => {
          
          // Recupera dados de filtros recebidos
          this.filtros.departamentos = res.data.Departamentos;
          this.filtros.categorias    = res.data.Categorias;
          this.filtros.marcas        = res.data.Marcas;
          this.filtros.geradores     = res.data.Geradores;
          this.filtros.voltagens     = res.data.Voltagens;
          this.filtros.potencias     = res.data.Potencias;

          if (!this.handlePotencia && this.filtros.potencias && this.filtros.potencias.length > 0) {
            // Tratativa Potencia Inicial
            this.potenciaSelecionada = [
              this.filtros.potencias[0].valor, 
              this.filtros.potencias[(this.filtros.potencias.length - 1)].valor
            ];
          } else if (this.handlePotencia) {
            let splitPotencia = potencias.split('-')
            this.potenciaSelecionada = [
              parseFloat(splitPotencia[0]), 
              parseFloat(splitPotencia[1])
            ];

            objPotencias.min = parseFloat(splitPotencia[0]);
            objPotencias.max = parseFloat(splitPotencia[1]);
          }

          // Busca Produtos utilizando os parâmetros de filtro selecionados
          axios({
            method: "post",
            data: {
              Departamentos: [ this.filtroDepartamentos ],
              Categorias: this.filtroCategorias,
              Marcas: this.filtroMarcas,
              Geradores: this.filtroGeradores,
              Voltagens: this.filtroVoltagens,
              Potencias:  objPotencias,
              TabelaPreco: this.canalVenda,
              isSaleSolar: this.isSolar
            },
            url: `https://www.leverosintegra.com.br/Map/Api/ProdutoLista?token=${this.token}`,
          }).then(res => {

            // Salva temporariamente os produtos
            let arrayProdutosTemp = res.data.lcardapio;

            // Busca a vigência de preços no Pricing
            axios.get("https://pricing-api.leverosservicos.com.br/price/solar")
            .then(responseData => {
              for (let i = 0; i < arrayProdutosTemp.length; i++) {
                let refId = arrayProdutosTemp[i].REFID;
                let datas = responseData.data.find((i) => i.productId == refId && i.priceList === this.canalVenda);
    
                arrayProdutosTemp[i].VALIDADE_ATE =
                  datas != undefined ? datas.finalDate : null;
                arrayProdutosTemp[i].VALIDADE_DE =
                  datas != undefined ? datas.initialDate : null;
              }

              // Atualiza array de produtos
              this.infos = arrayProdutosTemp;

              // Remove o Loading
              this.loading = false;
            })
          }).catch(err => {
            console.log(err)
          })

        }).catch(err => {
          console.log(err)
          localStorage.removeItem("login")
          window.location.href = (`${window.location.href}login`);
        })
      } catch (e) {
        console.log(e);
      }
    },
  },

  buscaFiltrosSolar() {

  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.productsSolar {
  max-width: 100%;
  margin: 0 auto;
  padding-top: 40px;

  @media (min-width: 769px) {
    max-width: 90%;
    flex-direction: row;
  }

  @media (min-width: 1920px) {
    max-width: 80%;
  }

  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 40px 0;

    h2 {
      color: var(--standardGreen);
    }

    hr {
      width: 10%;
      background: var(--standardGreen);
      height: 4px;
      margin-top: 5px;
      border: none;

      @media (max-width: 500px) {
        width: 30%;
      }
    }
  }

  .categoriesProduct {
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 769px) {
      flex-wrap: nowrap;
    }

    .sidebar {
      background: var(--customGray-70);
      border-radius: 5px;
      padding: 15px;

      &--mobile {
        display: block;
        min-width: 100%;
        border-radius: 0;
        margin-bottom: 25px;

        @media (min-width: 769px) {
          display: none;
        }
      }

      &--desktop {
        display: none;

        @media (min-width: 769px) {
          display: block;
          width: 25%;
        }
      }

      &__title {
        font-size: 1.4rem;
        color: var(--standardGreen);

        &--mobile {
          &::after {
            content: "(Abrir/Fechar Filtros)";
            position: relative;
            left: 10px;
            font-size: 0.85rem;
            vertical-align: middle;
            color: var(--customBlue);
          }
        }
      }

      &__options {
        h2 {
          font-size: 1.1rem;
          color: var(--customDarkGreen);
          padding: 20px 0 10px 0;
        }
      }

      &__item {
        list-style: none;
        cursor: pointer;
        padding: 5px 0;
        color: var(--customDarkGreen);
        font-size: 1rem;

        &:hover {
          color: var(--customGray-500);
        }
      }
    }

    .product {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      color: var(--customGray-500);
      margin-left: 0;
      width: 100%;

      @media (min-width: 769px) {
        width: 75%;
        height: 50%;
      }

      @media (min-width: 769px) {
        margin-left: 20px;
      }

      &__void {
        width: 90%;
        margin: 0 auto;
        padding: 20px;
        background: var(--customGray-70);
        border-radius: 5px;

        h2 {
          color: var(--standardGreen);
          padding-bottom: 20px;
          font-size: 1.2rem;
        }

        p {
          a {
            color: var(--customGray-500);
            padding-top: 20px;
          }
        }
      }

      &__list {
        margin: 5px;
        border: 1px solid var(--customGray-100);
        border-radius: 5px;
        padding: 25px 0;
        width: 100%;

        @media (min-width: 321px) and (max-width: 768px) {
          width: 48%;
          margin: 3px;
        }

        @media (min-width: 769px) {
          width: 32%;
        }

        &:hover {
          border: 1px solid var(--standardGreen);
          background: linear-gradient(
            10deg,
            rgba(0, 90, 100, 0.2839110644257703) 0%,
            rgba(0, 90, 100, 0.014) 45%
          );
        }
      }

      .pointer {
        cursor: pointer;
      }

      .imagem {
        display: flex;
        justify-content: center;
      }

      &__image {
        max-width: 220px;
        height: auto;
      }

      &__name {
        text-align: center;
        padding-bottom: 20px;
        font-size: 1rem;
      }

      &__price {
        display: flex;
        flex-direction: column;
        padding-left: 10px;

        @media (min-width: 441px) {
          padding-left: 15px;
        }

        .price {
          &__per {
            color: var(--standardGreen);
            font: 700 1.3rem "Soleto", sans-serif;
          }

          &__AtSight {
            font-size: 0.85rem;
          }

          &__priceTerm {
            padding: 3px 0;
            font-size: 0.95rem;
          }

          &__plots {
            font-size: 0.95rem;
          }

          &__lower-quantity {
            background-color: #ff000030;
            border-radius: 2px;
            width: 90%;
            margin: 15px 0 0 0;
            padding: 3px 0;
            text-align: center;
            font-size: 0.85rem;
          }
        }
      }

      &__buttons {
        padding-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column-reverse;

        @media (min-width: 1309px) {
          flex-direction: row;
        }

        &--details {
          border: 1px solid var(--customDarkGreen);
          border-radius: 5px;
          color: var(--customDarkGreen);
          font-size: 0.95rem;
          outline: none;
          margin: 10px 3px;
          width: 95%;
          padding: 11px;

          @media (min-width: 1309px) {
            margin: 0 10px;
            padding: 7px;
            width: initial;
          }
        }

        &--buy {
          background-color: var(--standardGreen);
          border-radius: 5px;
          color: var(--customWhite);
          font: 700 0.95rem "Soleto", sans-serif;
          outline: none;
          width: 95%;
          padding: 13px;

          @media (min-width: 1309px) {
            width: initial;
            padding: 7px;
          }
        }
      }
    }
  }
}

::v-deep .v-application--wrap {
  min-height: fit-content;
  
}
.theme--light.v-application {
  background: transparent !important;
}

.custom-slider {
  width: 100%;
  height: 2px;
  accent-color: #005a64;
}

</style>